import { Box, Flex, Icon, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaComment } from "react-icons/fa";
import { BseQuestionDto } from "../../../../../autogen/bff-api";
import { displayWrappedWithEllipsis } from "../../../../../common/formatting/displayWrappedWithEllipsis";
import { QuestionStatusTag } from "./QuestionStatusTag";

interface Props {
  items: BseQuestionDto[];
  getInfoSentence: (q: BseQuestionDto) => string;
  onRowClick: (id: string) => void;
  bordered?: boolean;
  emptyText: string;
}

export const QuestionsTable = ({ items, getInfoSentence, onRowClick, bordered = false, emptyText }: Props) => {
  const { t } = useTranslation();
  return (
    <Flex
      flexDirection="column"
      backgroundColor="smBackground"
      pt="5"
      pb="2.5"
      border={bordered ? "1px solid" : undefined}
      borderColor={bordered ? "smBorder" : undefined}
      rounded={bordered ? "md" : undefined}
      boxShadow={bordered ? "sm" : undefined}
    >
      <Table variant="simple" size="sm">
        <Thead>
          <Tr>
            <Th>{t("Subject")}</Th>
            <Th textAlign="center">{t("Status")}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {items.map((question) => (
            <Tr
              _hover={{ bg: "smBackgroundSecondary" }}
              cursor={"pointer"}
              key={question.id}
              onClick={() => onRowClick(question.id)}
            >
              <Td>
                <Box>{displayWrappedWithEllipsis(question.subject, 60)}</Box>
                <Box fontSize="sm" color="smMuted" pt="1">
                  {getInfoSentence(question)}
                </Box>
              </Td>
              <Td textAlign="center">
                <QuestionStatusTag status={question.status} />
                <Flex alignItems="center" justifyContent="center" fontWeight="semibold" pt="1">
                  {question.comments.length}
                  <Icon as={FaComment} color="smMuted" ml={2} />
                </Flex>
              </Td>
            </Tr>
          ))}
          {items.length === 0 && (
            <Tr>
              <Td colSpan={5} width={"100%"} textAlign="center">
                {emptyText}
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>
    </Flex>
  );
};
